<script lang="ts">
	import type { EmbedBlockData } from '$lib/queries/content/EmbedBlockQuery';
	import GetYoutubeId from '@tools/GetYoutubeId';
	import VideoBlock from './VideoBlock.svelte';
	import { cookies } from '@tools';
	import { Tracker } from '@tools/tracking/Tracker';
	import { Events } from '@tools/tracking/Enums';

	let { data }: { data: EmbedBlockData } = $props();

	const ytId = GetYoutubeId(data.src);

	let isPlayingSpotify = $state(false);

	const handleMessage = (e: MessageEvent) => {
		if (e.origin !== 'https://open.spotify.com') return;
		if (e.data.type === 'playback_update') {
			if (e.data.payload?.isPaused === undefined) return;
			const isPlaying = !e.data.payload.isPaused;
			if (isPlaying === isPlayingSpotify) return;

			isPlayingSpotify = isPlaying;
			if (isPlaying) Tracker.event(Events.PLAY_SPOTIFY, { event_id: data.src });
		}
	};
</script>

<svelte:window onmessage={handleMessage} />

{#if data.provider === 'youtube' && ytId}
	<VideoBlock
		data={{
			_modelApiKey: 'video_block',
			video: {
				provider: 'youtube',
				providerUid: ytId,
				width: 16,
				height: 9,
				thumbnailUrl: `https://img.youtube.com/vi/${ytId}/maxres1.jpg`,
				url: `https://www.youtube.com/embed/${ytId}?autoplay=1&color=white`
			}
		}}
	/>
{:else}
	<section
		class={`block:embed block:${data.provider === 'spotify' ? 'medium' : 'large'}`}
		style={data.aspectRatio ? `aspect-ratio: ${data.aspectRatio};` : ''}
	>
		{#if data.requiresConsent && !cookies.consents.get('marketing')}
			<button
				data-provider={data.provider}
				onclick={() => cookies.renewConsent()}
				style={`aspect-ratio: ${data.aspectRatio ? data.aspectRatio : 16 / 6};`}
			>
				<p>Venligst accepter <em>marketingcookies</em> for at se dette {data.providor}indhold</p>
			</button>
		{:else}
			<iframe
				src={data.src}
				style="border:none;"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
				loading="lazy"
				frameborder="0"
				allowfullscreen
				title={data.title}
				{...data.attributes}
			></iframe>
		{/if}
	</section>
{/if}

<style lang="scss">
	section {
		position: relative;
		display: flex;
		@include largeBlock;

		&.block\:medium {
			@include mediumBlock;

			&:global(:has(+ .block\:text.block\:medium)) {
				margin-bottom: $gap5;
			}
		}
	}

	button {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
		position: relative;
		background: radial-gradient(closest-side, $colorCardGraphic 100%, rgba(0, 0, 0, 0) 100%);
		background-repeat: repeat-x;
		background-size: calc(100% / 3) 100%;
	}
</style>
